// Test notification utility
export function testBrowserNotification() {
  if (!('Notification' in window)) {
    console.error('This browser does not support notifications');
    return;
  }

  if (Notification.permission === 'granted') {
    new Notification('Test Notification', {
      body: 'If you see this, browser notifications are working!',
      icon: '/favicon.png',
      badge: '/favicon.png',
      tag: 'test',
      requireInteraction: false
    });
    console.log('✅ Test notification sent');
  } else if (Notification.permission === 'denied') {
    console.error('❌ Notification permission denied');
  } else {
    console.log('⚠️ Notification permission not granted yet');
    Notification.requestPermission().then(permission => {
      if (permission === 'granted') {
        testBrowserNotification();
      }
    });
  }
}

// Check notification status
export function checkNotificationStatus() {
  console.log('=== Notification Status ===');
  console.log('Notification support:', 'Notification' in window);
  console.log('Permission:', Notification?.permission);
  console.log('Service Worker support:', 'serviceWorker' in navigator);
  
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      console.log('Service Worker registrations:', registrations.length);
      registrations.forEach((reg, i) => {
        console.log(`  [${i}] Scope:`, reg.scope);
        console.log(`  [${i}] Active:`, !!reg.active);
      });
    });
  }
  
  console.log('========================');
}

// Make functions available globally for testing
if (typeof window !== 'undefined') {
  window.testNotification = testBrowserNotification;
  window.checkNotificationStatus = checkNotificationStatus;
}
